import { render, staticRenderFns } from "./DealTimeToDeliverComponent.vue?vue&type=template&id=bdb839ea&scoped=true"
import script from "./DealTimeToDeliverComponent.vue?vue&type=script&lang=js"
export * from "./DealTimeToDeliverComponent.vue?vue&type=script&lang=js"
import "./DealTimeToDeliverComponent.vue?vue&type=style&index=0&id=bdb839ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb839ea",
  null
  
)

export default component.exports